import src from "IMAGE";
export default { src, width: 261, height: 61, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/AEAnAC5SRw5OM0odSzNKHUs4USBRV1UeV2pePHRFMAs4ABUNABAcFwQaERkKGRAYCRgVHhAdQVRPQyAoLi0UHh0WomELSCYjeuwAAAAASUVORK5CYII="};
